import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=4cbc8354&scoped=true"
import script from "./password-reset.vue?vue&type=script&lang=js"
export * from "./password-reset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc8354",
  null
  
)

export default component.exports